var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84459 1.51888C3.90328 1.51888 1.51888 3.90328 1.51888 6.84459C1.51888 9.78589 3.90328 12.1703 6.84459 12.1703C9.78589 12.1703 12.1703 9.78589 12.1703 6.84459C12.1703 3.90328 9.78589 1.51888 6.84459 1.51888ZM0.185547 6.84459C0.185547 3.1669 3.1669 0.185547 6.84459 0.185547C10.5223 0.185547 13.5036 3.1669 13.5036 6.84459C13.5036 10.5223 10.5223 13.5036 6.84459 13.5036C3.1669 13.5036 0.185547 10.5223 0.185547 6.84459Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5404 10.8526C10.8004 10.5919 11.2225 10.5914 11.4832 10.8514L13.8325 13.1946C14.0932 13.4546 14.0937 13.8768 13.8337 14.1374C13.5737 14.3981 13.1516 14.3987 12.8909 14.1387L10.5416 11.7954C10.2809 11.5354 10.2803 11.1133 10.5404 10.8526Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.70896ebcc179689b05e014fa5009d548.svg";
export { ForwardRef as ReactComponent };